// extracted by mini-css-extract-plugin
module.exports = {"t1dfkvvk":"t1dfkvvk","m1nuv3yl":"m1nuv3yl","title":"title","ratio":"ratio"};